var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validation-message"},[(_vm.validations[_vm.field])?_c('span',{staticClass:"text-danger small"},[_vm._v(" - "+_vm._s(_vm.validations[_vm.field])+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }